<footer>
    <a routerLink="/" id="logo">
        <img src="img/nav/logo-inverted.svg" alt="frontend developer">
    </a>

    <div>
        <p>&copy; André Groß 2026</p>
        <div id="links">
            <a routerLink="/legal-notes">Legal notice</a>
            <a routerLink="/privacy-policy">Privacy Policy</a>
        </div>
    </div>
</footer>